import { render, staticRenderFns } from "./AnfragenFinished.vue?vue&type=template&id=072697ec&scoped=true"
import script from "./AnfragenFinished.vue?vue&type=script&lang=js"
export * from "./AnfragenFinished.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072697ec",
  null
  
)

export default component.exports